export const ASSISE_PARTENAIRE_SHOW_RESET = "ASSISE_PARTENAIRE_SHOW_RESET";
export const ASSISE_PARTENAIRE_SHOW_SET_ERROR =
  "ASSISE_PARTENAIRE_SHOW_SET_ERROR";
export const ASSISE_PARTENAIRE_SHOW_SET_RETRIEVED =
  "ASSISE_PARTENAIRE_SHOW_SET_RETRIEVED";
export const ASSISE_PARTENAIRE_SHOW_TOGGLE_LOADING =
  "ASSISE_PARTENAIRE_SHOW_TOGGLE_LOADING";
